import {Component, OnInit, ElementRef, Output, EventEmitter} from '@angular/core';

// Services
import { TranslationService } from '../../services/translation.service';
import {Observable} from 'rxjs/Observable';
import {Store} from '@ngrx/store';
import * as fromCore from '../../../core/reducers';
import * as SortingActions from '../../../activities/sorting/actions/sorting.actions';

@Component({
  selector: 'language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.scss'],
  host: { '(document:click)': 'onClick($event)' }
})
export class LanguageDropdownComponent implements OnInit {
  // Output variables
  @Output() onItemSelect: EventEmitter<any> = new EventEmitter<any>();

  // Current lang
  public currentLang: string;
  public langsAvailable: Array<any>;
  public languageDropdownOpened: boolean = false;

  // Public Observable
  public currentLanguage$: Observable<any> = this.coreStore.select(state => state.core.ui.currentLanguage);

  // Constructor
  constructor(
    private _eref: ElementRef,
    private translationService: TranslationService,
    private coreStore: Store<fromCore.State>
  ) {}

  // On component init
  ngOnInit() {
    this.currentLanguage$.subscribe(currentLanguage => {
      if (currentLanguage) {
        this.currentLang = this.translationService.currentLangShortName;
      }
    });

    if (!this.currentLang) {
      this.currentLang = this.translationService.currentLangShortName;
    }
    this.langsAvailable = this.translationService.langsAvailable;
  }

  // Change language
  useLanguage(lang: string) {
    this.translationService.use(lang);
    this.languageDropdownOpened = false;
    this.currentLang = this.translationService.currentLangShortName;
    this.onItemSelect.emit(lang);
  }

  // On element click
  onClick(event) {
    if (!this._eref.nativeElement.contains(event.target) && this.languageDropdownOpened) {
      this.languageDropdownOpened = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/translation/components/language-dropdown/language-dropdown.component.ts